import { httpNoAuth } from "../index"
import { signinPayload, signupPayload, userForgotPasswordPayload, userGoogleSigninPayload, userGoogleSignupPayload } from "./auth-interface"

/**
 * User signup
 * @param data Object
 * @returns axios http response
 */
export const userSignup = (data: signupPayload) => {
  return httpNoAuth.post('/auth/register', data)
}

/**
 * User google signup
 * @param data Object
 * @returns axios http response
 */
export const userGoogleSignup = (data: userGoogleSignupPayload) => {
  return httpNoAuth.post('/auth/google-signup', data)
}


/**
 * User google signup
 * @param data Object
 * @returns axios http response
 */
export const userGoogleSignIn= (data: userGoogleSigninPayload) => {
  return httpNoAuth.post('/auth/google-login', data)
}

/**
 * User signin
 * @param data Object
 * @returns axios http response
 */
export const userSigin = (data: signinPayload) => {
  return httpNoAuth.post('/auth/login', data)
}

/**
 * User forgot password
 * @param data Object
 * @returns axios http response
 */
export const userForgotPassword = (data: userForgotPasswordPayload) => {
  return httpNoAuth.post('/auth/forgot-password', data)
}